export default {
      id: "pushpay-website-qr-code-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pushpay-website-qr-code",
      toString: function () {
        return this.url;
      }
    }